export default __webpack_public_path__ + "static/media/digital-empire-small-13@2x.ef3604b8.png";